onReady(() => {
    const contentBanners = Array.from(document.querySelectorAll('.content-banner'))
    for (const contentBanner of contentBanners) {
        const ctaButton = contentBanner.querySelector('.cta-button')
        if (ctaButton) {
            ctaButton.addEventListener('click', (event) => submitCtaClickEvent(event, ctaButton, contentBanner));
        }
    }
})
